import styled from "styled-components";
export default styled.div`
  margin: 2rem 0;
  padding: 2em;
  background-color: ${({ theme }) => theme.colors.dark};
  font-size: 2em;
  color: ${({ theme }) => theme.colors.foreground.inverted};
  font-weight: bold;
`;
